import * as styledutils from './styled.utils';
import axios from './axios';

export {
    axios,
    styledutils
};
